import { render } from "./DateSuplimentare.vue?vue&type=template&id=4bd33336&scoped=true&ts=true"
import script from "./DateSuplimentare.vue?vue&type=script&lang=ts"
export * from "./DateSuplimentare.vue?vue&type=script&lang=ts"

import "./DateSuplimentare.vue?vue&type=style&index=0&id=4bd33336&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd33336"]])

export default __exports__